import rutasGenericas from "../../config/apiBase";

const apiSinBases = {
  modelo: "inspector",
};

const usuarioApi = rutasGenericas(apiSinBases);

export default usuarioApi;
